import RadioButtonChecked from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import WebRounded from "@mui/icons-material/WebRounded";
import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import type { EmailDesign } from "../../../../email-design/server/supabase-email-design-service";
import type { ToolbarProps } from "./props";
import { ToolbarDropDown } from "./toolbar-drop-down";
import { ToolbarIconButton } from "./toolbar-icon-button";

export const EmailTemplateSelector: FC<
  ToolbarProps & {
    emailDesigns: EmailDesign[];
    selectedEmailDesign: EmailDesign | undefined;
    setEmailDesign: (ed: EmailDesign | undefined) => void;
  }
> = ({ disabled, emailDesigns, selectedEmailDesign, setEmailDesign, mode }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (emailDesigns.length < 2) {
    return null;
  }

  return (
    <ToolbarDropDown
      data-analytics-id="lexical-toolbar-dropdown-template-selector"
      disabled={disabled}
      icon={<WebRounded />}
      heading="Template"
      open={open}
      setOpen={setOpen}
      mode={mode}
    >
      {emailDesigns.map((template) => (
        <ToolbarIconButton
          data-analytics-id={`lexical-toolbar-email-template-${template.name}`}
          key={template.id}
          icon={
            selectedEmailDesign?.id === template.id ? (
              <RadioButtonChecked />
            ) : (
              <RadioButtonUnchecked />
            )
          }
          label={t(template.name)}
          onClick={() => {
            setEmailDesign(template);
          }}
        />
      ))}
    </ToolbarDropDown>
  );
};
